import 'css/components/classrooms/classroom-card.css'
import plusIcon from 'img/plus-blue.svg'
import { Link } from 'react-router-dom'
import { Class } from 'types'

export const ClassroomCard = ({ classroom }: { classroom: Class }) => {
    return (
        <Link to={`/classrooms/${classroom.classId}`} className="classroom-card" onClick={() => window.scrollTo(0, 0)}>
            <div className="card-row">
                <h2 className="card-title">{classroom.name}</h2>
            </div>
            <p className="card-description">{classroom.subject} · Period {classroom.period}</p>
        </Link>
    )
}

export const CreateClassroomCard = ({handleCreateClassroom}: {handleCreateClassroom: () => void}) => {
    return (
        <div className="classroom-card create-classroom-card" onClick={handleCreateClassroom}>
            <img src={plusIcon} alt="Create Classroom" />
            Create Classroom
        </div>
    )
}

export const ArchivedClassesCard = ({ onClick }: { onClick: () => void }) => {
    return (
        <div className="classroom-card archived-classes-card" onClick={onClick}>
            <svg width="25" height="25" viewBox="0 0 24 24" fill="#709CC8" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="3" width="20" height="4" rx="1" />
                <path d="M3 8h18v11a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                <rect x="9" y="12.5" width="6" height="1.5" rx="0.75" fill="white" />
            </svg>
            Archived Classes
        </div>
    )
}
